import { useMemo } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { useTheme } from '../contexts/ThemeContext';
import { buildMuiTheme } from './muiTheme';

/**
 * Bridges the app's ThemeContext (the single switch) to MUI.
 * When ThemeContext flips isDark, this rebuilds the MUI theme from the same
 * token source, so MUI surfaces and the CSS-var layer stay in lock-step.
 *
 * Placed INSIDE the custom ThemeProvider so useTheme() is available.
 */
export default function MuiThemeBridge({ children }) {
  const { isDark } = useTheme();
  const muiTheme = useMemo(() => buildMuiTheme(isDark ? 'dark' : 'light'), [isDark]);

  return (
    <MuiThemeProvider theme={muiTheme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
}
